import { useEffect, useState } from "react";
import app from "nystem";
import { Link, Wrapper } from "nystem-components";

const MissionStagesView = ({ model }) => {
  const [count, setCount] = useState({});
  const { option } = app.contentType.mission.item.find(({ id }) => id === "status");

  useEffect(() => {
    const load = async () => {
      const { data = [] } = await app.database.mission.search({ count: 100000 });
      setCount(data.reduce((count, { status }) => ({ ...count, [status]: (count[status] || 0) + 1 }), {}));
    };
    load();
    app.database.mission.on("update", load);
    return () => app.database.mission.off("update", load);
  }, []);

  const chip = [
    "flex items-center gap-2 whitespace-nowrap rounded-full border border-stone-200 bg-white px-3 py-1.5 text-sm",
    "font-medium text-stone-600 hover:border-emerald-300",
    "[&.active]:border-emerald-800 [&.active]:bg-emerald-800 [&.active]:text-white",
  ];

  return (
    <Wrapper className={[model.className, "flex gap-2 overflow-x-auto pb-1"]}>
      <Link to="/" className={chip}>
        {app.t("All")}
      </Link>
      {option.map(({ _id, text }) => (
        <Link key={_id} to={`/stage/${_id}`} className={chip}>
          {app.t(text)}
          <Wrapper className="rounded-full bg-black/10 px-1.5 text-xs">{count[_id] || 0}</Wrapper>
        </Link>
      ))}
    </Wrapper>
  );
};

export default MissionStagesView;
